import React from 'react';
import './PieChart.css';

const PieChart = ({ data, size = 300, selectedSegment = null }) => {
  const total = data.reduce((sum, item) => sum + item.value, 0);
  
  let currentAngle = -90; // Start at top
  const segments = data.map((item, index) => {
    const percentage = (item.value / total) * 100;
    const angle = (item.value / total) * 360;
    
    const segment = {
      ...item,
      percentage,
      startAngle: currentAngle,
      angle
    };
    
    currentAngle += angle;
    return segment;
  });

  const colors = [
    '#4f46e5', // Purple
    '#10b981', // Green
    '#f59e0b', // Orange
    '#ec4899', // Pink - Neuroscience
    '#8b5cf6'  // Light purple
  ];

  const createArc = (startAngle, angle, isSelected = false) => {
    const start = (startAngle * Math.PI) / 180;
    const end = ((startAngle + angle) * Math.PI) / 180;
    const largeArc = angle > 180 ? 1 : 0;
    
    // Slightly expand selected segment
    const radius = isSelected ? 150 : 140;
    
    const x1 = 150 + radius * Math.cos(start);
    const y1 = 150 + radius * Math.sin(start);
    const x2 = 150 + radius * Math.cos(end);
    const y2 = 150 + radius * Math.sin(end);
    
    return `M 150 150 L ${x1} ${y1} A ${radius} ${radius} 0 ${largeArc} 1 ${x2} ${y2} Z`;
  };

  return (
    <div className="pie-chart-container">
      <svg width={size} height={size} viewBox="0 0 300 300" className="pie-chart-svg">
        {segments.map((segment, index) => {
          const isSelected = segment.label === selectedSegment;
          return (
            <g key={index}>
              <path
                d={createArc(segment.startAngle, segment.angle, isSelected)}
                fill={colors[index % colors.length]}
                className={`pie-segment ${isSelected ? 'pie-segment-selected' : ''}`}
                data-label={segment.label}
              />
            </g>
          );
        })}
        {/* Center white circle for donut effect */}
        <circle cx="150" cy="150" r="80" fill="white" />
        <text x="150" y="145" textAnchor="middle" className="pie-center-value">
          {total.toLocaleString()}
        </text>
        <text x="150" y="165" textAnchor="middle" className="pie-center-label">
          User Interactions
        </text>
      </svg>
      <div className="pie-legend">
        {segments.map((segment, index) => {
          const isSelected = segment.label === selectedSegment;
          return (
            <div key={index} className={`pie-legend-item ${isSelected ? 'pie-legend-item-selected' : ''}`}>
              <div 
                className="pie-legend-color" 
                style={{ background: colors[index % colors.length] }}
              ></div>
              <div className="pie-legend-text">
                <div className="pie-legend-label">{segment.label}</div>
                <div className="pie-legend-value">
                  {segment.value.toLocaleString()} ({segment.percentage.toFixed(1)}%)
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PieChart;
